import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKExpenseDetail implements EntityAware {
    @serialize
    @deserialize
    public jenis_pengeluaran_id: number = 0;

    @serialize
    @deserialize
    public jenis_pemasukan_id: number = 0;

    @serialize
    @deserialize
    public nominal: number = 0;
}
